<template>
    <!-- 首页 2 -->
    <div class="contents section-hero">
        <div class="container">
            <div class="row col-lg-12">
                <div class="col-lg-7 d-flex flex-column">
                    <div class="row_box">
                        <h1>{{ title }}</h1>
                        <h1>{{ subtitle }}</h1>
                        <div class="lead-lines">
                            <p v-for="(line, index) in leadLines" :key="'lead-' + index">{{ line }}</p>
                        </div>
                        <ul class="feature-list">
                            <li v-for="(item, index) in features" :key="'feat-' + index">{{ item }}</li>
                        </ul>
                    </div>
                    <div class="d-flex flex-wrap align-items-center home-two-actions">
                        <button type="button" class="btn btn-outline-success mt-4">{{ buttonText }}</button>
                        <a
                            class="btn btn-outline-success mt-4"
                            :href="linkAccountPdf"
                            target="_blank"
                            rel="noopener noreferrer"
                        >{{ buttonLinkAccount }}</a>
                    </div>
                </div>
                <div class="col-lg-5" style="margin-top: 40px;">
                    <img class="img-fluid" src="/img/pay/0--86.png" alt="">
                </div>
            </div>
        </div>
    </div>

</template>
<script>
export default {
    name: 'homeTwo',
    data() {
        return {

        };
    },
    computed: {
        title() {
            return this.$t('homeTwo.title');
        },
        subtitle() {
            return this.$t('homeTwo.subtitle');
        },
        leadLines() {
            return this.$t('homeTwo.leadLines');
        },
        features() {
            return this.$t('homeTwo.features');
        },
        buttonText() {
            return this.$i18n.locale === 'en'
                ? this.$t('homeTwo.buttonOpen')
                : this.$t('common.buttonText');
        },
        buttonLinkAccount() {
            return this.$t('homeTwo.buttonLinkAccount');
        },
        linkAccountPdf() {
            return this.$t('homeTwo.linkAccountPdf');
        },
    },
};
</script>
<style scoped lang="scss">
.contents {
    background-image: url('/img/pay/0--85.png');
    background-position: center;
    // background-repeat: no-repeat;
    background-size: cover;
      height: var(--main-height);

}
.container {
    height: 100%;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;

    .row_box {
        flex: 1;

        h1 {
            font-weight: 800;
            color: #233dd2;
            margin: 0;
        }

        h1:first-child {
            color: #333;
            margin-bottom: 14px;
            margin-top: 50px;
        }

        .lead-lines {
            margin-top: 28px;

            p {
                font-size: 18px;
                line-height: 1.5;
                color: #333333;
                margin: 0 0 10px;
            }
        }

        .feature-list {
            list-style: none;
            padding-left: 0;
            margin: 24px 0 0;

            li {
                position: relative;
                padding-left: 1.35em;
                font-size: 18px;
                line-height: 1.6;
                color: #333333;
                margin-bottom: 8px;

                &::before {
                    content: '✔';
                    position: absolute;
                    left: 0;
                    color: #333333;
                    font-size: 0.95em;
                }
            }
        }
    }
}

.home-two-actions {
    gap: 12px;

    .btn + .btn {
        margin-left: 0;
    }
}
</style>
